import CampDeJourStep from './custom-steps/camp-de-jour-step';
import EnfantsFicheSanteInfoStep from './custom-steps/enfants-info-step';
import BoutiqueStep from './custom-steps/boutique-step';
import PanierStep from './custom-steps/panier-step';
// import PaiementStep from './custom-steps/paiement-step';

export const formulaireCampDeJour = [
  // Step 0: Custom component
  {
    customComponent: CampDeJourStep,
    title: 'Sélection de la période'
  },
  // Step 1: Custom component pour la boutique de chandails
  {
    customComponent: BoutiqueStep,
    title: 'Boutique'
  },
  // Step 2: Informations de paiement et de facturation
  {
    customComponent: PanierStep,
    title: 'Panier'
  },
  // Step 3: Paiement
  // {
  //   customComponent: PaiementStep,
  //   title: 'Paiement'
  // },
  // Step 3: Mock step – shown on stepper only (user never reaches this step in this flow; real formulaire is on another route)
  {
    title: 'Formulaire',
    mockStep: true
  }
]

export const formulaireFicheSanteEnfant = [
  {
    customComponent: EnfantsFicheSanteInfoStep,
    title: 'Fiche de santé de l\'enfant'
  }
]

export const exampleNormalFields = [
  // BoldTitle (12) - Very large bold title
  {
    idFormulaireDetail: '0af5e74c-d894-4206-9359-d6d36c6b7ae7',
    descriptionFrancaise: 'Formulaire de réservation',
    descriptionAnglaise: 'Reservation form',
    typeChamp: 12, // BoldTitle
    requis: false,
    idChampBaseDonnees: 0,
    idUsagerCreation: '00000000-0000-0000-0000-000000000000',
    idUsagerModification: '00000000-0000-0000-0000-000000000000',
    idUsagerSuppression: null,
    dateCreation: new Date().toISOString(),
    dateModification: new Date().toISOString(),
    dateSuppression: null
  },

  // BoldLabel (11) - Large bold text
  {
    idFormulaireDetail: 'b81800f0-475a-4846-a30f-f15c7b4a3ed9',
    descriptionFrancaise: 'Informations personnelles',
    descriptionAnglaise: 'Personal information',
    typeChamp: 11, // BoldLabel
    requis: false,
    idChampBaseDonnees: 0,
    idUsagerCreation: '00000000-0000-0000-0000-000000000000',
    idUsagerModification: '00000000-0000-0000-0000-000000000000',
    idUsagerSuppression: null,
    dateCreation: new Date().toISOString(),
    dateModification: new Date().toISOString(),
    dateSuppression: null
  },

  // Label (0) - Display only text
  {
    idFormulaireDetail: '6c55c8bd-d408-4b5c-a607-0a563b48ebb9',
    descriptionFrancaise: 'Informations générales',
    descriptionAnglaise: 'General information',
    typeChamp: 0, // Label
    requis: false,
    idChampBaseDonnees: 0,
    idUsagerCreation: '00000000-0000-0000-0000-000000000000',
    idUsagerModification: '00000000-0000-0000-0000-000000000000',
    idUsagerSuppression: null,
    dateCreation: new Date().toISOString(),
    dateModification: new Date().toISOString(),
    dateSuppression: null
  },
  // Text (1) - Text input
  {
    idFormulaireDetail: '535c4f3b-4cf6-44da-b7f3-c3d92b546515',
    descriptionFrancaise: 'Nom',
    descriptionAnglaise: 'Last name',
    typeChamp: 1, // Text
    requis: true,
    maxLength: 50,
    idChampBaseDonnees: 0,
    idUsagerCreation: '00000000-0000-0000-0000-000000000000',
    idUsagerModification: '00000000-0000-0000-0000-000000000000',
    idUsagerSuppression: null,
    dateCreation: new Date().toISOString(),
    dateModification: new Date().toISOString(),
    dateSuppression: null
  },
  // Text (1) - Another text input
  {
    idFormulaireDetail: '6c75cb08-9200-4216-9156-5b147aee7416',
    descriptionFrancaise: 'Prénom',
    descriptionAnglaise: 'First name',
    typeChamp: 1, // Text
    requis: true,
    maxLength: 50,
    value: 'Jean'
  },
  // Memo (2) - Textarea
  {
    idFormulaireDetail: 'e6528597-2707-47ab-90cd-b01ae7dc7bde',
    descriptionFrancaise: 'Commentaires',
    descriptionAnglaise: 'Comments',
    typeChamp: 2, // Memo
    requis: false,
    maxLength: 500,
    value: 'Merci pour votre service!',
    idChampBaseDonnees: 0,
    idUsagerCreation: '00000000-0000-0000-0000-000000000000',
    idUsagerModification: '00000000-0000-0000-0000-000000000000',
    idUsagerSuppression: null,
    dateCreation: new Date().toISOString(),
    dateModification: new Date().toISOString(),
    dateSuppression: null
  },
  // Numeric (3) - Integer number
  {
    idFormulaireDetail: '2aa9ad67-937e-48b4-b57d-814a0e623000',
    descriptionFrancaise: 'Nombre de personnes',
    descriptionAnglaise: 'Number of people',
    typeChamp: 3, // Numeric
    requis: true,
    min: 1,
    max: 20,
    valeurDefaut: 1,
    value: 2
  },
  // Decimal (4) - Decimal number
  {
    idFormulaireDetail: 'bbf347ec-711f-4ea6-beb8-4095eba24d81',
    descriptionFrancaise: 'Montant',
    descriptionAnglaise: 'Amount',
    typeChamp: 4, // Decimal
    requis: false,
    min: 0,
    max: 10000,
    valeurDefaut: 0,
    value: 150.50,
    idChampBaseDonnees: 0,
    idUsagerCreation: '00000000-0000-0000-0000-000000000000',
    idUsagerModification: '00000000-0000-0000-0000-000000000000',
    idUsagerSuppression: null,
    dateCreation: new Date().toISOString(),
    dateModification: new Date().toISOString(),
    dateSuppression: null
  },
  // CheckBox (5) - Single checkbox
  {
    idFormulaireDetail: 'fe48d8fd-f993-4463-bc1e-c405d676244f',
    descriptionFrancaise: 'J\'accepte les conditions',
    descriptionAnglaise: 'I accept the conditions',
    typeChamp: 5, // CheckBox
    requis: true,
    description: 'Je confirme avoir lu et accepté les conditions générales',
    valeurDefaut: false,
    value: true,
    idChampBaseDonnees: 0,
    idUsagerCreation: '00000000-0000-0000-0000-000000000000',
    idUsagerModification: '00000000-0000-0000-0000-000000000000',
    idUsagerSuppression: null,
    dateCreation: new Date().toISOString(),
    dateModification: new Date().toISOString(),
    dateSuppression: null
  },
  // Date (6) - Date picker
  {
    idFormulaireDetail: '1d2ce1d9-7fa8-49d3-b61f-3ae0e794cdf1',
    descriptionFrancaise: 'Date de naissance',
    descriptionAnglaise: 'Date of birth',
    typeChamp: 6, // Date
    requis: true,
    min: '1900-01-01',
    max: new Date().toISOString().split('T')[0],
    valeurDefaut: '',
    idChampBaseDonnees: 0,
    idUsagerCreation: '00000000-0000-0000-0000-000000000000',
    idUsagerModification: '00000000-0000-0000-0000-000000000000',
    idUsagerSuppression: null,
    dateCreation: new Date().toISOString(),
    dateModification: new Date().toISOString(),
    dateSuppression: null
  },
  // Date (6) - Another date field
  {
    idFormulaireDetail: '0b9f2b18-07ac-4a59-9385-68dcadd1f02c',
    descriptionFrancaise: 'Date d\'arrivée',
    descriptionAnglaise: 'Arrival date',
    typeChamp: 6, // Date
    requis: true,
    min: new Date().toISOString().split('T')[0],
    max: '2099-12-31',
    idChampBaseDonnees: 0,
    idUsagerCreation: '00000000-0000-0000-0000-000000000000',
    idUsagerModification: '00000000-0000-0000-0000-000000000000',
    idUsagerSuppression: null,
    dateCreation: new Date().toISOString(),
    dateModification: new Date().toISOString(),
    dateSuppression: null
  },
  // DateTime (7) - Date and time picker
  {
    idFormulaireDetail: '665668ab-a2dc-4f08-8426-d6a000a0ff83',
    descriptionFrancaise: 'Date et heure de réservation',
    descriptionAnglaise: 'Reservation date and time',
    typeChamp: 7, // DateTime
    requis: false,
    valeurDefaut: '',
    idChampBaseDonnees: 0,
    idUsagerCreation: '00000000-0000-0000-0000-000000000000',
    idUsagerModification: '00000000-0000-0000-0000-000000000000',
    idUsagerSuppression: null,
    dateCreation: new Date().toISOString(),
    dateModification: new Date().toISOString(),
    dateSuppression: null
  },
  // BoldLabel (11) - Large bold text for section
  {
    idFormulaireDetail: '951d6ffe-45f2-4b7f-800f-8ef6492d8ac8',
    descriptionFrancaise: 'Préférences de Réservation',
    descriptionAnglaise: 'Reservation Preferences',
    typeChamp: 11, // BoldLabel
    requis: false,
    idChampBaseDonnees: 0,
    idUsagerCreation: '00000000-0000-0000-0000-000000000000',
    idUsagerModification: '00000000-0000-0000-0000-000000000000',
    idUsagerSuppression: null,
    dateCreation: new Date().toISOString(),
    dateModification: new Date().toISOString(),
    dateSuppression: null
  },
  // RadioGroup (8) - Radio buttons
  {
    idFormulaireDetail: '8612f5b0-bd50-44ac-9ba6-1b5ee26438c7',
    descriptionFrancaise: 'Type de réservation',
    descriptionAnglaise: 'Reservation type',
    typeChamp: 8, // RadioGroup
    requis: true,
    listeChoix: 'Journée;Soirée;Week-end;Semaine complète',
    valeurDefaut: '',
    value: 'weekend',
    idChampBaseDonnees: 0,
    idUsagerCreation: '00000000-0000-0000-0000-000000000000',
    idUsagerModification: '00000000-0000-0000-0000-000000000000',
    idUsagerSuppression: null,
    dateCreation: new Date().toISOString(),
    dateModification: new Date().toISOString(),
    dateSuppression: null
  },
  // RadioGroup (8) - Another radio group (horizontal layout)
  {
    idFormulaireDetail: 'd1bcb6b0-7931-42fe-9e3a-41f98d2d178f',
    descriptionFrancaise: 'Niveau d\'expérience',
    descriptionAnglaise: 'Experience level',
    typeChamp: 8, // RadioGroup
    requis: false,
    affichageHorizontal: true, // Display radio buttons horizontally
    listeChoix: 'Débutant;Intermédiaire;Avancé;Expert',
    value: 'intermediaire',
    idChampBaseDonnees: 0,
    idUsagerCreation: '00000000-0000-0000-0000-000000000000',
    idUsagerModification: '00000000-0000-0000-0000-000000000000',
    idUsagerSuppression: null,
    dateCreation: new Date().toISOString(),
    dateModification: new Date().toISOString(),
    dateSuppression: null
  },
  // CheckedListBox (9) - Multiple checkboxes
  {
    idFormulaireDetail: 'a355e852-47a7-4b83-a5f1-72c9d2bc55d4',
    descriptionFrancaise: 'Équipements souhaités',
    descriptionAnglaise: 'Desired equipment',
    typeChamp: 9, // CheckedListBox
    requis: false,
    listeChoix: 'Tente;Sac de couchage;Réchaud;Glacière;Lanterne',
    valeurDefaut: [],
    value: ['tente', 'sacCouchage']
  },
  // CheckedListBox (9) - Another checked list (horizontal layout)
  {
    idFormulaireDetail: '75b97c14-ca15-4223-9125-6f818473998a',
    descriptionFrancaise: 'Activités d\'intérêt',
    descriptionAnglaise: 'Activities of interest',
    typeChamp: 9, // CheckedListBox
    requis: false,
    affichageHorizontal: true, // Display checkboxes horizontally
    listeChoix: 'Pêche;Randonnée;Canoë;Observation de la faune;Photographie',
    valeurDefaut: [],
    value: ['peche', 'randonnee']
  },
  // BoldLabel (11) - Large bold text for section
  {
    idFormulaireDetail: '49709fb2-a0e8-402e-aa8a-8722f6f0e3a9',
    descriptionFrancaise: 'Informations de Contact',
    descriptionAnglaise: 'Contact Information',
    typeChamp: 11, // BoldLabel
    requis: false,
    idChampBaseDonnees: 0,
    idUsagerCreation: '00000000-0000-0000-0000-000000000000',
    idUsagerModification: '00000000-0000-0000-0000-000000000000',
    idUsagerSuppression: null,
    dateCreation: new Date().toISOString(),
    dateModification: new Date().toISOString(),
    dateSuppression: null
  },
  // DropDownList (10) - Select dropdown
  {
    idFormulaireDetail: '0d2709e6-9ff2-4066-9e81-be9d295667b3',
    descriptionFrancaise: 'Province',
    descriptionAnglaise: 'Province',
    typeChamp: 10, // DropDownList
    requis: true,
    listeChoix: 'Québec;Ontario;Nouveau-Brunswick;Nouvelle-Écosse;Île-du-Prince-Édouard;Terre-Neuve-et-Labrador;Manitoba;Saskatchewan;Alberta;Colombie-Britannique;Yukon;Territoires du Nord-Ouest;Nunavut',
    valeurDefaut: '',
    value: 'qc',
    idChampBaseDonnees: 0,
    idUsagerCreation: '00000000-0000-0000-0000-000000000000',
    idUsagerModification: '00000000-0000-0000-0000-000000000000',
    idUsagerSuppression: null,
    dateCreation: new Date().toISOString(),
    dateModification: new Date().toISOString(),
    dateSuppression: null
  },
  // DropDownList (10) - Another dropdown
  {
    idFormulaireDetail: '1750c4b2-b5ac-44c9-96f1-05c308ab495e',
    descriptionFrancaise: 'Type de véhicule',
    descriptionAnglaise: 'Vehicle type',
    typeChamp: 10, // DropDownList
    requis: false,
    listeChoix: 'Automobile;Camionnette;Motocyclette;Véhicule tout-terrain;Autre',
    value: 'auto',
    idChampBaseDonnees: 0,
    idUsagerCreation: '00000000-0000-0000-0000-000000000000',
    idUsagerModification: '00000000-0000-0000-0000-000000000000',
    idUsagerSuppression: null,
    dateCreation: new Date().toISOString(),
    dateModification: new Date().toISOString(),
    dateSuppression: null
  },
  // Text (1) - Read-only field
  {
    idFormulaireDetail: 'edcef67c-57d8-4f8a-a0bc-ffbb0d317c2e',
    descriptionFrancaise: 'Numéro de réservation',
    descriptionAnglaise: 'Reservation number',
    typeChamp: 1, // Text
    requis: false,
    readOnly: true,
    valeurDefaut: 'RES-2024-001',
    value: 'RES-2024-001',
    idChampBaseDonnees: 0,
    idUsagerCreation: '00000000-0000-0000-0000-000000000000',
    idUsagerModification: '00000000-0000-0000-0000-000000000000',
    idUsagerSuppression: null,
    dateCreation: new Date().toISOString(),
    dateModification: new Date().toISOString(),
    dateSuppression: null
  }
];

// Minimal example with just a few fields
export const minimalExampleFields = [
  // BoldTitle (12) - Very large bold title
  {
    idFormulaireDetail: '218d0945-b985-487c-a1cb-dc67167144b7',
    descriptionFrancaise: 'Formulaire Simple',
    descriptionAnglaise: 'Simple Form',
    typeChamp: 12, // BoldTitle
    requis: false,
    idChampBaseDonnees: 0,
    idUsagerCreation: '00000000-0000-0000-0000-000000000000',
    idUsagerModification: '00000000-0000-0000-0000-000000000000',
    idUsagerSuppression: null,
    dateCreation: new Date().toISOString(),
    dateModification: new Date().toISOString(),
    dateSuppression: null
  },
  // BoldLabel (11) - Large bold text
  {
    idFormulaireDetail: '30cb3eed-212f-4bdd-a1c9-6fc14f589175',
    descriptionFrancaise: 'Informations Requises',
    descriptionAnglaise: 'Required Information',
    typeChamp: 11, // BoldLabel
    requis: false,
    idChampBaseDonnees: 0,
    idUsagerCreation: '00000000-0000-0000-0000-000000000000',
    idUsagerModification: '00000000-0000-0000-0000-000000000000',
    idUsagerSuppression: null,
    dateCreation: new Date().toISOString(),
    dateModification: new Date().toISOString(),
    dateSuppression: null
  },
  {
    idFormulaireDetail: '9f368009-21ca-43bf-901a-6e9c8762155c',
    descriptionFrancaise: 'Nom',
    descriptionAnglaise: 'Last name',
    typeChamp: 1, // Text
    requis: true,
    idChampBaseDonnees: 0,
    idUsagerCreation: '00000000-0000-0000-0000-000000000000',
    idUsagerModification: '00000000-0000-0000-0000-000000000000',
    idUsagerSuppression: null,
    dateCreation: new Date().toISOString(),
    dateModification: new Date().toISOString(),
    dateSuppression: null
  },
  {
    idFormulaireDetail: 'c828f26f-4fa6-4f0f-a874-49c8d680a9f9',
    descriptionFrancaise: 'Courriel',
    descriptionAnglaise: 'Email',
    typeChamp: 1, // Text
    requis: true,
    placeholder: 'exemple@email.com',
    idChampBaseDonnees: 0,
    idUsagerCreation: '00000000-0000-0000-0000-000000000000',
    idUsagerModification: '00000000-0000-0000-0000-000000000000',
    idUsagerSuppression: null,
    dateCreation: new Date().toISOString(),
    dateModification: new Date().toISOString(),
    dateSuppression: null
  },
  {
    idFormulaireDetail: '9146a543-9369-4e04-9b0c-a1f2822ffb58',
    descriptionFrancaise: 'Date',
    descriptionAnglaise: 'Date',
    typeChamp: 6, // Date
    requis: true,
    idChampBaseDonnees: 0,
    idUsagerCreation: '00000000-0000-0000-0000-000000000000',
    idUsagerModification: '00000000-0000-0000-0000-000000000000',
    idUsagerSuppression: null,
    dateCreation: new Date().toISOString(),
    dateModification: new Date().toISOString(),
    dateSuppression: null
  }
];

// Multi-section multiple étapes
export const multiEtapesExampleFields = [
  // Step 0: Introduction
  [
    {
      idFormulaireDetail: '8a355a2e-2800-488b-b96c-294ef023681e',
      descriptionFrancaise: 'Bienvenue',
      descriptionAnglaise: 'Welcome',
      typeChamp: 12, // BoldTitle
      requis: false,
      idChampBaseDonnees: 0,
      idUsagerCreation: '00000000-0000-0000-0000-000000000000',
      idUsagerModification: '00000000-0000-0000-0000-000000000000',
      idUsagerSuppression: null,
      dateCreation: new Date().toISOString(),
      dateModification: new Date().toISOString(),
      dateSuppression: null
    },
    {
      idFormulaireDetail: 'cf462117-6d41-450d-80ba-76085e11b80d',
      descriptionFrancaise: 'Bienvenue dans notre formulaire de réservation',
      descriptionAnglaise: 'Welcome to our reservation form',
      typeChamp: 0, // Label
      requis: false,
      idChampBaseDonnees: 0,
      idUsagerCreation: '00000000-0000-0000-0000-000000000000',
      idUsagerModification: '00000000-0000-0000-0000-000000000000',
      idUsagerSuppression: null,
      dateCreation: new Date().toISOString(),
      dateModification: new Date().toISOString(),
      dateSuppression: null
    },
    {
      idFormulaireDetail: '7b30f2a3-b1c3-46df-bacf-1f22aae3ec7b',
      descriptionFrancaise: 'Ce formulaire est divisé en plusieurs étapes. Veuillez remplir chaque section avec soin.',
      descriptionAnglaise: 'This form is divided into several steps. Please fill out each section carefully.',
      typeChamp: 0, // Label
      requis: false,
      idChampBaseDonnees: 0,
      idUsagerCreation: '00000000-0000-0000-0000-000000000000',
      idUsagerModification: '00000000-0000-0000-0000-000000000000',
      idUsagerSuppression: null,
      dateCreation: new Date().toISOString(),
      dateModification: new Date().toISOString(),
      dateSuppression: null
    },
    {
      idFormulaireDetail: '8363e628-2436-492e-9c36-4c5adc0d02f2',
      descriptionFrancaise: 'Nom',
      descriptionAnglaise: 'Last name',
      typeChamp: 1, // Text
      requis: true,
      maxLength: 50,
      placeholder: 'Entrez votre nom',
      value: '',
      idChampBaseDonnees: 0,
      idUsagerCreation: '00000000-0000-0000-0000-000000000000',
      idUsagerModification: '00000000-0000-0000-0000-000000000000',
      idUsagerSuppression: null,
      dateCreation: new Date().toISOString(),
      dateModification: new Date().toISOString(),
      dateSuppression: null
    },
    {
      idFormulaireDetail: 'c1ac1432-1f5a-44a1-85ad-58ef7a4a70c2',
      descriptionFrancaise: 'Prénom',
      descriptionAnglaise: 'First name',
      typeChamp: 1, // Text
      requis: true,
      maxLength: 50,
      value: '',
      idChampBaseDonnees: 0,
      idUsagerCreation: '00000000-0000-0000-0000-000000000000',
      idUsagerModification: '00000000-0000-0000-0000-000000000000',
      idUsagerSuppression: null,
      dateCreation: new Date().toISOString(),
      dateModification: new Date().toISOString(),
      dateSuppression: null
    },
    {
      idFormulaireDetail: '1bb12f2f-4f5a-44a1-85ad-58gf7a4a70c2',
      descriptionFrancaise: 'Êtes-vous éligible au programme de bourse ?',
      descriptionAnglaise: 'Are you eligible for the scholarship program?',
      typeChamp: 8, // Radio group
      requis: true,
      affichageHorizontal: true,
      listeChoix: 'Oui;Non',
      value: '',
      idChampBaseDonnees: 0,
      idUsagerCreation: '00000000-0000-0000-0000-000000000000',
      idUsagerModification: '00000000-0000-0000-0000-000000000000',
      idUsagerSuppression: null,
      dateCreation: new Date().toISOString(),
      dateModification: new Date().toISOString(),
      dateSuppression: null
    },
    {
      idFormulaireDetail: 'faae700e-edf2-4762-ba93-ce3955212a92',
      descriptionFrancaise: 'Courriel',
      descriptionAnglaise: 'Email',
      typeChamp: 1, // Text
      requis: true,
      placeholder: 'exemple@email.com',
      value: ''
    }
  ],
  // Step 1: Informations Personnelles et Réservation
  [
    // Section 1: Title
    {
      idFormulaireDetail: 'c9d6d1c8-eb4a-4f3b-afad-fe5f823cf571',
      descriptionFrancaise: 'Formulaire de Réservation',
      descriptionAnglaise: 'Reservation Form',
      typeChamp: 12, // BoldTitle
      requis: false,
      idChampBaseDonnees: 0,
      idUsagerCreation: '00000000-0000-0000-0000-000000000000',
      idUsagerModification: '00000000-0000-0000-0000-000000000000',
      idUsagerSuppression: null,
      dateCreation: new Date().toISOString(),
      dateModification: new Date().toISOString(),
      dateSuppression: null
    },

    // Section 1: Informations Personnelles
    {
      idFormulaireDetail: 'f66a2229-ed23-4779-b515-78ca4f5e8162',
      descriptionFrancaise: 'Informations Personnelles',
      descriptionAnglaise: 'Personal Information',
      typeChamp: 11, // BoldLabel
      requis: false,
      idChampBaseDonnees: 0,
      idUsagerCreation: '00000000-0000-0000-0000-000000000000',
      idUsagerModification: '00000000-0000-0000-0000-000000000000',
      idUsagerSuppression: null,
      dateCreation: new Date().toISOString(),
      dateModification: new Date().toISOString(),
      dateSuppression: null
    },
    {
      idFormulaireDetail: '6ea5efe0-43f2-4cd6-9d01-4e91411ebe2d',
      descriptionFrancaise: 'Nom',
      descriptionAnglaise: 'Last name',
      typeChamp: 1, // Text
      requis: true,
      maxLength: 50,
      placeholder: 'Entrez votre nom',
    },
    {
      idFormulaireDetail: '17fd4c99-6b1e-4a69-8df6-732badb1feaf',
      descriptionFrancaise: 'Prénom',
      descriptionAnglaise: 'First name',
      typeChamp: 1, // Text
      requis: true,
      maxLength: 50,
      value: 'Jean'
    },
    {
      idFormulaireDetail: '8266ac02-d2ed-4de6-9d3a-43be82a0e398',
      descriptionFrancaise: 'Courriel',
      descriptionAnglaise: 'Email',
      typeChamp: 1, // Text
      requis: true,
      placeholder: 'exemple@email.com',
    },
    {
      idFormulaireDetail: '4c9ccb8e-4ac0-4d16-99fc-a696f4df6d4b',
      descriptionFrancaise: 'Téléphone',
      descriptionAnglaise: 'Phone',
      typeChamp: 1, // Text
      requis: true,
      placeholder: '(123) 456-7890'
    },

    // Section 2: Informations de Réservation
    {
      idFormulaireDetail: '32845d7a-6e1c-4bd8-be84-b997c6662918',
      descriptionFrancaise: 'Informations de Réservation',
      descriptionAnglaise: 'Reservation Information',
      typeChamp: 11, // BoldLabel
      requis: false,
      idChampBaseDonnees: 0,
      idUsagerCreation: '00000000-0000-0000-0000-000000000000',
      idUsagerModification: '00000000-0000-0000-0000-000000000000',
      idUsagerSuppression: null,
      dateCreation: new Date().toISOString(),
      dateModification: new Date().toISOString(),
      dateSuppression: null
    },
    {
      idFormulaireDetail: '5f3d41c6-7e32-4b0f-b971-2121871a0f84',
      descriptionFrancaise: 'Date d\'arrivée',
      descriptionAnglaise: 'Arrival date',
      typeChamp: 6, // Date
      requis: true,
      min: new Date().toISOString().split('T')[0],
      idChampBaseDonnees: 0,
      idUsagerCreation: '00000000-0000-0000-0000-000000000000',
      idUsagerModification: '00000000-0000-0000-0000-000000000000',
      idUsagerSuppression: null,
      dateCreation: new Date().toISOString(),
      dateModification: new Date().toISOString(),
      dateSuppression: null
    },
    {
      idFormulaireDetail: 'b62dd7d9-55bf-49d7-9942-fb8cbf8c5109',
      descriptionFrancaise: 'Date de départ',
      descriptionAnglaise: 'Departure date',
      typeChamp: 6, // Date
      requis: true,
      min: new Date().toISOString().split('T')[0],
      idChampBaseDonnees: 0,
      idUsagerCreation: '00000000-0000-0000-0000-000000000000',
      idUsagerModification: '00000000-0000-0000-0000-000000000000',
      idUsagerSuppression: null,
      dateCreation: new Date().toISOString(),
      dateModification: new Date().toISOString(),
      dateSuppression: null
    },
    {
      idFormulaireDetail: '999473f7-b08e-416b-bbd0-eb01db71f5fd',
      descriptionFrancaise: 'Nombre de personnes',
      descriptionAnglaise: 'Number of people',
      typeChamp: 3, // Numeric
      requis: true,
      min: 1,
      max: 20,
      valeurDefaut: 1,
      value: 2
    },
    {
      idFormulaireDetail: '18ff7971-78c0-40af-b288-f1faf4f6d95f',
      descriptionFrancaise: 'Type de réservation',
      descriptionAnglaise: 'Reservation type',
      typeChamp: 8, // RadioGroup
      requis: true,
      affichageHorizontal: true,
      listeChoix: 'Journée;Soirée;Week-end;Semaine complète',
      value: 'weekend'
    },

    // Section 3: Préférences
    {
      idFormulaireDetail: '4c45e8f7-6e01-4585-b3f4-208cf81c9f56',
      descriptionFrancaise: 'Préférences',
      descriptionAnglaise: 'Preferences',
      typeChamp: 11, // BoldLabel
      requis: false,
      idChampBaseDonnees: 0,
      idUsagerCreation: '00000000-0000-0000-0000-000000000000',
      idUsagerModification: '00000000-0000-0000-0000-000000000000',
      idUsagerSuppression: null,
      dateCreation: new Date().toISOString(),
      dateModification: new Date().toISOString(),
      dateSuppression: null
    },
    {
      idFormulaireDetail: '5c9b51d1-4fe3-4e11-8849-e2ef2229074e',
      descriptionFrancaise: 'Équipements souhaités',
      descriptionAnglaise: 'Desired equipment',
      typeChamp: 9, // CheckedListBox
      requis: false,
      affichageHorizontal: true,
      listeChoix: 'Tente;Sac de couchage;Réchaud;Glacière',
      valeurDefaut: [],
      value: ['tente', 'sacCouchage']
    },
    {
      idFormulaireDetail: '3ee24d3d-3ac7-4d1f-aec3-2989d18523ea',
      descriptionFrancaise: 'Activités d\'intérêt',
      descriptionAnglaise: 'Activities of interest',
      typeChamp: 9, // CheckedListBox
      requis: false,
      affichageHorizontal: false,
      listeChoix: 'Pêche;Randonnée;Canoë;Observation de la faune',
      valeurDefaut: []
    },
    {
      idFormulaireDetail: '62791397-ea9c-4e24-b8a0-8c28594eb64a',
      descriptionFrancaise: 'Niveau d\'expérience',
      descriptionAnglaise: 'Experience level',
      typeChamp: 8, // RadioGroup
      requis: false,
      affichageHorizontal: true,
      listeChoix: 'Débutant;Intermédiaire;Avancé',
      value: 'intermediaire'
    },

    // Section 4: Commentaires
    {
      idFormulaireDetail: 'bd408a0d-83ef-441c-bf81-ff60852c7f1e',
      descriptionFrancaise: 'Commentaires et Informations Supplémentaires',
      descriptionAnglaise: 'Comments and Additional Information',
      typeChamp: 11, // BoldLabel
      requis: false,
      idChampBaseDonnees: 0,
      idUsagerCreation: '00000000-0000-0000-0000-000000000000',
      idUsagerModification: '00000000-0000-0000-0000-000000000000',
      idUsagerSuppression: null,
      dateCreation: new Date().toISOString(),
      dateModification: new Date().toISOString(),
      dateSuppression: null
    },
    {
      idFormulaireDetail: 'effcefb0-06e1-44dc-9bb7-3f7e645b70de',
      descriptionFrancaise: 'Commentaires',
      descriptionAnglaise: 'Comments',
      typeChamp: 2, // Memo
      requis: false,
      maxLength: 500,
      placeholder: 'Ajoutez vos commentaires ou informations supplémentaires ici...',
      idChampBaseDonnees: 0,
      idUsagerCreation: '00000000-0000-0000-0000-000000000000',
      idUsagerModification: '00000000-0000-0000-0000-000000000000',
      idUsagerSuppression: null,
      dateCreation: new Date().toISOString(),
      dateModification: new Date().toISOString(),
      dateSuppression: null
    },
    {
      idFormulaireDetail: '4bb30139-5eff-4486-ad37-a3593b9e08cb',
      descriptionFrancaise: 'J\'accepte les conditions',
      descriptionAnglaise: 'I accept the conditions',
      typeChamp: 5, // CheckBox
      requis: true,
      description: 'Je confirme avoir lu et accepté les conditions générales',
      valeurDefaut: false,
      idChampBaseDonnees: 0,
      idUsagerCreation: '00000000-0000-0000-0000-000000000000',
      idUsagerModification: '00000000-0000-0000-0000-000000000000',
      idUsagerSuppression: null,
      dateCreation: new Date().toISOString(),
      dateModification: new Date().toISOString(),
      dateSuppression: null
    }
  ],
  // Step 2: Confirmation et Finalisation
  [
    {
      idFormulaireDetail: '8363e628-2436-492e-9c36-4c5adc0d02f2',
      descriptionFrancaise: 'Détails de l\'Adresse',
      descriptionAnglaise: 'Address Details',
      typeChamp: 12, // BoldTitle
      requis: false,
      idChampBaseDonnees: 0,
      idUsagerCreation: '00000000-0000-0000-0000-000000000000',
      idUsagerModification: '00000000-0000-0000-0000-000000000000',
      idUsagerSuppression: null,
      dateCreation: new Date().toISOString(),
      dateModification: new Date().toISOString(),
      dateSuppression: null
    },
    {
      idFormulaireDetail: 'c1ac1432-1f5a-44a1-85ad-58ef7a4a70c2',
      descriptionFrancaise: 'Révision',
      descriptionAnglaise: 'Review',
      typeChamp: 11, // BoldLabel
      requis: false,
      idChampBaseDonnees: 0,
      idUsagerCreation: '00000000-0000-0000-0000-000000000000',
      idUsagerModification: '00000000-0000-0000-0000-000000000000',
      idUsagerSuppression: null,
      dateCreation: new Date().toISOString(),
      dateModification: new Date().toISOString(),
      dateSuppression: null
    },
    {
      idFormulaireDetail: 'faae700e-edf2-4762-ba93-ce3955212a92',
      descriptionFrancaise: 'Veuillez réviser toutes les informations que vous avez saisies.',
      descriptionAnglaise: 'Please review all the information you have entered.',
      typeChamp: 0, // Label
      requis: false,
      idChampBaseDonnees: 0,
      idUsagerCreation: '00000000-0000-0000-0000-000000000000',
      idUsagerModification: '00000000-0000-0000-0000-000000000000',
      idUsagerSuppression: null,
      dateCreation: new Date().toISOString(),
      dateModification: new Date().toISOString(),
      dateSuppression: null
    },
    {
      idFormulaireDetail: '5afc1a2b-f4ea-4669-ae0e-7cb1086a6cd0',
      descriptionFrancaise: 'Je confirme que toutes les informations sont exactes',
      descriptionAnglaise: 'I confirm that all information is accurate',
      typeChamp: 5, // CheckBox
      requis: true,
      description: 'Je confirme que toutes les informations sont exactes et je souhaite finaliser ma réservation',
      valeurDefaut: false,
      idChampBaseDonnees: 0,
      idUsagerCreation: '00000000-0000-0000-0000-000000000000',
      idUsagerModification: '00000000-0000-0000-0000-000000000000',
      idUsagerSuppression: null,
      dateCreation: new Date().toISOString(),
      dateModification: new Date().toISOString(),
      dateSuppression: null
    }
  ]
];


// Example with column layout
export const columnsExampleFields = [
  // Main Title
  {
    idFormulaireDetail: '3807eee0-740d-46c4-9078-7edeb217fbdc',
    descriptionFrancaise: 'Formulaire avec Colonnes',
    descriptionAnglaise: 'Form with Columns',
    typeChamp: 12, // BoldTitle
    requis: false,
    idChampBaseDonnees: 0,
    idUsagerCreation: '00000000-0000-0000-0000-000000000000',
    idUsagerModification: '00000000-0000-0000-0000-000000000000',
    idUsagerSuppression: null,
    dateCreation: new Date().toISOString(),
    dateModification: new Date().toISOString(),
    dateSuppression: null
  },

  // Section 1: Two columns layout
  {
    idFormulaireDetail: '4f14373e-04e6-4889-87b6-5e29bb236885',
    descriptionFrancaise: '1 RÉPONDANT(S) DE L\'ENFANT',
    descriptionAnglaise: '1 RESPONDENT(S) OF THE CHILD',
    typeChamp: 11, // BoldLabel
    requis: false,
    colonnes: 2 // This section will have 2 columns
  },
  // Column 1: PARENT 1
  {
    idFormulaireDetail: 'd19db773-6a10-4cb1-991c-7756590be5b7',
    descriptionFrancaise: 'Prénom et nom du PARENT 1:',
    descriptionAnglaise: 'First and last name of PARENT 1:',
    typeChamp: 1, // Text
    requis: true,
  },
  {
    idFormulaireDetail: '7934a82b-aa98-4a22-8b35-89e331e82aac',
    descriptionFrancaise: 'Téléphone (principal)',
    descriptionAnglaise: 'Phone (primary)',
    typeChamp: 1, // Text
    requis: true,
    value: '514-123-4567'
  },
  {
    idFormulaireDetail: '871e134f-d9de-4118-a3b2-f285af937e61',
    descriptionFrancaise: 'Poste:',
    descriptionAnglaise: 'Extension:',
    typeChamp: 1, // Text
    requis: false,
    idChampBaseDonnees: 0,
    idUsagerCreation: '00000000-0000-0000-0000-000000000000',
    idUsagerModification: '00000000-0000-0000-0000-000000000000',
    idUsagerSuppression: null,
    dateCreation: new Date().toISOString(),
    dateModification: new Date().toISOString(),
    dateSuppression: null
  },
  {
    idFormulaireDetail: 'c45fb033-7c5a-4c72-8339-be9e685c7377',
    descriptionFrancaise: 'Téléphone (autre) *Non obligatoire*',
    descriptionAnglaise: 'Phone (other) *Optional*',
    typeChamp: 1, // Text
    requis: false,
    idChampBaseDonnees: 0,
    idUsagerCreation: '00000000-0000-0000-0000-000000000000',
    idUsagerModification: '00000000-0000-0000-0000-000000000000',
    idUsagerSuppression: null,
    dateCreation: new Date().toISOString(),
    dateModification: new Date().toISOString(),
    dateSuppression: null
  },
  // Column 2: PARENT 2
  {
    idFormulaireDetail: '0eacd150-a874-46c7-80bf-5799322a7d47',
    descriptionFrancaise: 'Prénom et nom du PARENT 2:',
    descriptionAnglaise: 'First and last name of PARENT 2:',
    typeChamp: 1, // Text
    requis: true,
    value: 'Martin'
  },
  {
    idFormulaireDetail: '23e66eb1-14b8-4572-a879-d3b373c1ffbf',
    descriptionFrancaise: 'Téléphone (principal)',
    descriptionAnglaise: 'Phone (primary)',
    typeChamp: 1, // Text
    requis: true,
    value: '514-987-6543'
  },
  {
    idFormulaireDetail: 'de242453-abaa-4256-b65e-c2e717bdde8f',
    descriptionFrancaise: 'Poste:',
    descriptionAnglaise: 'Extension:',
    typeChamp: 1, // Text
    requis: false,
    idChampBaseDonnees: 0,
    idUsagerCreation: '00000000-0000-0000-0000-000000000000',
    idUsagerModification: '00000000-0000-0000-0000-000000000000',
    idUsagerSuppression: null,
    dateCreation: new Date().toISOString(),
    dateModification: new Date().toISOString(),
    dateSuppression: null
  },
  {
    idFormulaireDetail: '1485b5d8-7f7c-47a6-b79f-ee72608e8fdb',
    descriptionFrancaise: 'Téléphone (autre) *Non obligatoire*',
    descriptionAnglaise: 'Phone (other) *Optional*',
    typeChamp: 1, // Text
    requis: false,
    idChampBaseDonnees: 0,
    idUsagerCreation: '00000000-0000-0000-0000-000000000000',
    idUsagerModification: '00000000-0000-0000-0000-000000000000',
    idUsagerSuppression: null,
    dateCreation: new Date().toISOString(),
    dateModification: new Date().toISOString(),
    dateSuppression: null
  },

  // Section 2: Vertical layout (single column)
  {
    idFormulaireDetail: '740b13dc-41d4-4607-8d4a-0a8a353e00d7',
    descriptionFrancaise: '2. EN CAS D\'URGENCE',
    descriptionAnglaise: '2. IN CASE OF EMERGENCY',
    typeChamp: 11, // BoldLabel
    requis: false,
    colonnes: 1 // This section will be vertical (default)
  },
  {
    idFormulaireDetail: '8a871388-6af1-441f-8c26-d31a8fdae4f8',
    descriptionFrancaise: 'Personne à joindre en cas d\'URGENCE:',
    descriptionAnglaise: 'Person to contact in case of EMERGENCY:',
    typeChamp: 0, // Label
    requis: false,
    idChampBaseDonnees: 0,
    idUsagerCreation: '00000000-0000-0000-0000-000000000000',
    idUsagerModification: '00000000-0000-0000-0000-000000000000',
    idUsagerSuppression: null,
    dateCreation: new Date().toISOString(),
    dateModification: new Date().toISOString(),
    dateSuppression: null
  },
  {
    idFormulaireDetail: '65c8bda2-8d6c-4fbe-8936-b8856ef4f62b',
    descriptionFrancaise: 'Choix',
    descriptionAnglaise: 'Choice',
    typeChamp: 9, // CheckedListBox
    requis: false,
    affichageHorizontal: true,
    listeChoix: 'Parent 1 et Parent 2;Parent 1;Parent 2;Tuteur(s)',
    valeurDefaut: [],
    idChampBaseDonnees: 0,
    idUsagerCreation: '00000000-0000-0000-0000-000000000000',
    idUsagerModification: '00000000-0000-0000-0000-000000000000',
    idUsagerSuppression: null,
    dateCreation: new Date().toISOString(),
    dateModification: new Date().toISOString(),
    dateSuppression: null
  },

  // Section 3: Two columns for emergency contacts
  {
    idFormulaireDetail: 'f34a68b1-9e4d-45ed-bf9f-0eccec9d629e',
    descriptionFrancaise: 'Deux autres personnes à joindre en cas d\'URGENCE:',
    descriptionAnglaise: 'Two other people to contact in case of EMERGENCY:',
    typeChamp: 11, // BoldLabel
    requis: false,
    colonnes: 2 // This section will have 2 columns
  },
  // Column 1: Contact 1
  {
    idFormulaireDetail: 'e470c290-1699-464d-b289-131ae3cdd512',
    descriptionFrancaise: 'Prénom et nom:',
    descriptionAnglaise: 'First and last name:',
    typeChamp: 1, // Text
    requis: true,
    idChampBaseDonnees: 0,
    idUsagerCreation: '00000000-0000-0000-0000-000000000000',
    idUsagerModification: '00000000-0000-0000-0000-000000000000',
    idUsagerSuppression: null,
    dateCreation: new Date().toISOString(),
    dateModification: new Date().toISOString(),
    dateSuppression: null
  },
  {
    idFormulaireDetail: '812cbc30-ec07-4aff-b8ca-2065ef248567',
    descriptionFrancaise: 'Lien avec l\'enfant:',
    descriptionAnglaise: 'Relationship with child:',
    typeChamp: 1, // Text
    requis: true,
    idChampBaseDonnees: 0,
    idUsagerCreation: '00000000-0000-0000-0000-000000000000',
    idUsagerModification: '00000000-0000-0000-0000-000000000000',
    idUsagerSuppression: null,
    dateCreation: new Date().toISOString(),
    dateModification: new Date().toISOString(),
    dateSuppression: null
  },
  {
    idFormulaireDetail: 'a3444081-7d68-4cd8-ac63-bbe62bc4d65e',
    descriptionFrancaise: 'Téléphone (principal)',
    descriptionAnglaise: 'Phone (primary)',
    typeChamp: 1, // Text
    requis: true,
    idChampBaseDonnees: 0,
    idUsagerCreation: '00000000-0000-0000-0000-000000000000',
    idUsagerModification: '00000000-0000-0000-0000-000000000000',
    idUsagerSuppression: null,
    dateCreation: new Date().toISOString(),
    dateModification: new Date().toISOString(),
    dateSuppression: null
  },
  {
    idFormulaireDetail: 'f0892ec8-33f6-4f1a-b4da-4064d045be93',
    descriptionFrancaise: 'Téléphone (autre): *Non obligatoire*',
    descriptionAnglaise: 'Phone (other): *Optional*',
    typeChamp: 1, // Text
    requis: false,
    idChampBaseDonnees: 0,
    idUsagerCreation: '00000000-0000-0000-0000-000000000000',
    idUsagerModification: '00000000-0000-0000-0000-000000000000',
    idUsagerSuppression: null,
    dateCreation: new Date().toISOString(),
    dateModification: new Date().toISOString(),
    dateSuppression: null
  },
  // Column 2: Contact 2
  {
    idFormulaireDetail: 'eae907b2-d042-41ab-a81f-d87d15dcc148',
    descriptionFrancaise: 'Prénom et nom:',
    descriptionAnglaise: 'First and last name:',
    typeChamp: 1, // Text
    requis: true,
    idChampBaseDonnees: 0,
    idUsagerCreation: '00000000-0000-0000-0000-000000000000',
    idUsagerModification: '00000000-0000-0000-0000-000000000000',
    idUsagerSuppression: null,
    dateCreation: new Date().toISOString(),
    dateModification: new Date().toISOString(),
    dateSuppression: null
  },
  {
    idFormulaireDetail: '7307477b-ef7e-4ba9-bda9-0db925d96079',
    descriptionFrancaise: 'Lien avec l\'enfant:',
    descriptionAnglaise: 'Relationship with child:',
    typeChamp: 1, // Text
    requis: true,
    idChampBaseDonnees: 0,
    idUsagerCreation: '00000000-0000-0000-0000-000000000000',
    idUsagerModification: '00000000-0000-0000-0000-000000000000',
    idUsagerSuppression: null,
    dateCreation: new Date().toISOString(),
    dateModification: new Date().toISOString(),
    dateSuppression: null
  },
  {
    idFormulaireDetail: '45c03cd9-174d-4e49-832f-72f0852c670b',
    descriptionFrancaise: 'Téléphone (principal)',
    descriptionAnglaise: 'Phone (primary)',
    typeChamp: 1, // Text
    requis: true,
    idChampBaseDonnees: 0,
    idUsagerCreation: '00000000-0000-0000-0000-000000000000',
    idUsagerModification: '00000000-0000-0000-0000-000000000000',
    idUsagerSuppression: null,
    dateCreation: new Date().toISOString(),
    dateModification: new Date().toISOString(),
    dateSuppression: null
  },
  {
    idFormulaireDetail: '6afb947f-be00-4576-a470-813c88f882bc',
    descriptionFrancaise: 'Téléphone (autre): *Non obligatoire*',
    descriptionAnglaise: 'Phone (other): *Optional*',
    typeChamp: 1, // Text
    requis: false
  }
];


// Example with 4 vertical sections
export const fourSectionsExampleFields = [
  // Main Title
  {
    idFormulaireDetail: '99ecf0f0-d371-4f97-847d-13ab37e8f5d0',
    descriptionFrancaise: 'Formulaire en 4 Sections',
    descriptionAnglaise: 'Form with 4 Sections',
    typeChamp: 12, // BoldTitle
    requis: false,
    idChampBaseDonnees: 0,
    idUsagerCreation: '00000000-0000-0000-0000-000000000000',
    idUsagerModification: '00000000-0000-0000-0000-000000000000',
    idUsagerSuppression: null,
    dateCreation: new Date().toISOString(),
    dateModification: new Date().toISOString(),
    dateSuppression: null
  },

  // Section 1: Informations Personnelles
  {
    idFormulaireDetail: 'bb9aa4bd-d8d0-445a-984a-6e2f05bef91c',
    descriptionFrancaise: '1. INFORMATIONS PERSONNELLES',
    descriptionAnglaise: '1. PERSONAL INFORMATION',
    typeChamp: 11, // BoldLabel
    requis: false,
    colonnes: 1,
    idChampBaseDonnees: 0,
    idUsagerCreation: '00000000-0000-0000-0000-000000000000',
    idUsagerModification: '00000000-0000-0000-0000-000000000000',
    idUsagerSuppression: null,
    dateCreation: new Date().toISOString(),
    dateModification: new Date().toISOString(),
    dateSuppression: null
  },
  {
    idFormulaireDetail: '5141c66f-33bc-45b3-810b-e030e0c0ee9b',
    descriptionFrancaise: 'Nom',
    descriptionAnglaise: 'Last name',
    typeChamp: 1, // Text
    requis: true,
    maxLength: 50,
  },
  {
    idFormulaireDetail: '90e1dbce-f36f-45e7-bcae-c6419ead793f',
    descriptionFrancaise: 'Prénom',
    descriptionAnglaise: 'First name',
    typeChamp: 1, // Text
    requis: true,
    maxLength: 50,
    value: 'Jean'
  },
  {
    idFormulaireDetail: '840f79f3-dea0-4d55-954c-faa72350577f',
    descriptionFrancaise: 'Date de naissance',
    descriptionAnglaise: 'Date of birth',
    typeChamp: 6, // Date
    requis: true,
    min: '1900-01-01',
    max: new Date().toISOString().split('T')[0]
  },
  {
    idFormulaireDetail: '1259a6b3-eade-4027-84f0-7bfce76043b6',
    descriptionFrancaise: 'Courriel',
    descriptionAnglaise: 'Email',
    typeChamp: 1, // Text
    requis: true,
    placeholder: 'exemple@email.com',
  },

  // Section 2: Informations de Contact
  {
    idFormulaireDetail: '4c682b7e-11fc-43ea-9cba-d400dc690447',
    descriptionFrancaise: '2. INFORMATIONS DE CONTACT',
    descriptionAnglaise: '2. CONTACT INFORMATION',
    typeChamp: 11, // BoldLabel
    requis: false,
    colonnes: 1,
    idChampBaseDonnees: 0,
    idUsagerCreation: '00000000-0000-0000-0000-000000000000',
    idUsagerModification: '00000000-0000-0000-0000-000000000000',
    idUsagerSuppression: null,
    dateCreation: new Date().toISOString(),
    dateModification: new Date().toISOString(),
    dateSuppression: null
  },
  {
    idFormulaireDetail: '8a896716-0e13-4a75-966d-37c5caedf376',
    descriptionFrancaise: 'Adresse',
    descriptionAnglaise: 'Address',
    typeChamp: 1, // Text
    requis: true,
    maxLength: 100,
    placeholder: '123 Rue Principale',
    value: '123 Rue Principale'
  },
  {
    idFormulaireDetail: 'f1143e36-19c8-4784-9f8a-29b975d5a34d',
    descriptionFrancaise: 'Ville',
    descriptionAnglaise: 'City',
    typeChamp: 1, // Text
    requis: true,
    maxLength: 50,
    placeholder: 'Montréal',
    value: 'Montréal'
  },
  {
    idFormulaireDetail: '43723ceb-8908-499e-9d27-294a6c3bb9f6',
    descriptionFrancaise: 'Code postal',
    descriptionAnglaise: 'Postal code',
    typeChamp: 1, // Text
    requis: true,
    maxLength: 10,
    placeholder: 'H1A 1A1',
    value: 'H1A 1A1'
  },
  {
    idFormulaireDetail: '67db9a18-7f92-4cb3-9895-a94d8a794205',
    descriptionFrancaise: 'Téléphone principal',
    descriptionAnglaise: 'Main phone',
    typeChamp: 1, // Text
    requis: true,
    placeholder: '(514) 123-4567',
    value: '514-123-4567'
  },
  {
    idFormulaireDetail: '46cd081f-ed60-4f3e-bed9-be56ce363087',
    descriptionFrancaise: 'Téléphone secondaire',
    descriptionAnglaise: 'Secondary phone',
    typeChamp: 1, // Text
    requis: false,
    placeholder: '(514) 987-6543'
  },

  // Section 3: Préférences
  {
    idFormulaireDetail: '219904d1-efb7-4d7a-8ebe-890151344b46',
    descriptionFrancaise: '3. PRÉFÉRENCES',
    descriptionAnglaise: '3. PREFERENCES',
    typeChamp: 11, // BoldLabel
    requis: false,
    colonnes: 1,
    pleineLargeur: true // Full width section
  },
  {
    idFormulaireDetail: '4cd93b3f-0748-4d4c-98a9-7c1e7c6cb59c',
    descriptionFrancaise: 'Type de réservation',
    descriptionAnglaise: 'Reservation type',
    typeChamp: 8, // RadioGroup
    requis: true,
    affichageHorizontal: true,
    listeChoix: 'Journée;Soirée;Week-end;Semaine complète',
    value: 'weekend'
  },
  {
    idFormulaireDetail: '163d8fe0-44ba-4865-92c6-dfe27bab1870',
    descriptionFrancaise: 'Nombre de personnes',
    descriptionAnglaise: 'Number of people',
    typeChamp: 3, // Numeric
    requis: true,
    min: 1,
    max: 20,
    valeurDefaut: 1,
    value: 2
  },
  {
    idFormulaireDetail: '28a6a99b-53b2-47c8-b68f-08035e979a39',
    descriptionFrancaise: 'Équipements souhaités',
    descriptionAnglaise: 'Desired equipment',
    typeChamp: 9, // CheckedListBox
    requis: false,
    affichageHorizontal: true,
    listeChoix: 'Tente;Sac de couchage;Réchaud;Glacière;Lanterne',
    valeurDefaut: [],
    value: ['tente', 'sacCouchage']
  },
  {
    idFormulaireDetail: '888780c7-1bba-472c-aa0f-d09c72f1cdc8',
    descriptionFrancaise: 'Activités d\'intérêt',
    descriptionAnglaise: 'Activities of interest',
    typeChamp: 9, // CheckedListBox
    requis: false,
    affichageHorizontal: false,
    listeChoix: 'Pêche;Randonnée;Canoë;Observation de la faune;Photographie',
    valeurDefaut: [],
    value: ['peche', 'randonnee']
  },

  // Section 4: Commentaires et Conditions
  {
    idFormulaireDetail: '4690d523-27e7-4788-a5e6-a790c0ab3f81',
    descriptionFrancaise: '4. COMMENTAIRES ET CONDITIONS',
    descriptionAnglaise: '4. COMMENTS AND CONDITIONS',
    typeChamp: 11, // BoldLabel
    requis: false,
    colonnes: 1,
    idChampBaseDonnees: 0,
    idUsagerCreation: '00000000-0000-0000-0000-000000000000',
    idUsagerModification: '00000000-0000-0000-0000-000000000000',
    idUsagerSuppression: null,
    dateCreation: new Date().toISOString(),
    dateModification: new Date().toISOString(),
    dateSuppression: null
  },
  {
    idFormulaireDetail: '96fd0db2-fdbf-4c96-beec-88b12cb3c4e7',
    descriptionFrancaise: 'Commentaires',
    descriptionAnglaise: 'Comments',
    typeChamp: 2, // Memo
    requis: false,
    maxLength: 500,
    placeholder: 'Ajoutez vos commentaires ou informations supplémentaires ici...',
    idChampBaseDonnees: 0,
    idUsagerCreation: '00000000-0000-0000-0000-000000000000',
    idUsagerModification: '00000000-0000-0000-0000-000000000000',
    idUsagerSuppression: null,
    dateCreation: new Date().toISOString(),
    dateModification: new Date().toISOString(),
    dateSuppression: null
  },
  {
    idFormulaireDetail: '502a5227-05a9-44e2-84fe-93273b65ce86',
    descriptionFrancaise: 'Besoins spéciaux',
    descriptionAnglaise: 'Special needs',
    typeChamp: 2, // Memo
    requis: false,
    maxLength: 300,
    placeholder: 'Indiquez vos besoins spéciaux ou accessibilité requise...'
  },
  {
    idFormulaireDetail: '9c47d9f1-1eeb-446e-8a40-5d197f577f0a',
    descriptionFrancaise: 'J\'accepte les conditions',
    descriptionAnglaise: 'I accept the conditions',
    typeChamp: 5, // CheckBox
    requis: true,
    description: 'Je confirme avoir lu et accepté les conditions générales et la politique de confidentialité',
    valeurDefaut: false,
    idChampBaseDonnees: 0,
    idUsagerCreation: '00000000-0000-0000-0000-000000000000',
    idUsagerModification: '00000000-0000-0000-0000-000000000000',
    idUsagerSuppression: null,
    dateCreation: new Date().toISOString(),
    dateModification: new Date().toISOString(),
    dateSuppression: null
  },
  {
    idFormulaireDetail: 'c44dc86a-a470-43bd-9ac5-c5ead33148d8',
    descriptionFrancaise: 'Je souhaite recevoir la newsletter',
    descriptionAnglaise: 'I wish to receive the newsletter',
    typeChamp: 5, // CheckBox
    requis: false,
    description: 'Recevez nos dernières nouvelles et offres spéciales',
    valeurDefaut: false,
    idChampBaseDonnees: 0,
    idUsagerCreation: '00000000-0000-0000-0000-000000000000',
    idUsagerModification: '00000000-0000-0000-0000-000000000000',
    idUsagerSuppression: null,
    dateCreation: new Date().toISOString(),
    dateModification: new Date().toISOString(),
    dateSuppression: null
  },

  // Section 5: Paiement et Confirmation
  {
    idFormulaireDetail: 'efa14b29-10cf-4d6f-b066-94662953af1c',
    descriptionFrancaise: '5. PAIEMENT ET CONFIRMATION',
    descriptionAnglaise: '5. PAYMENT AND CONFIRMATION',
    typeChamp: 11, // BoldLabel
    requis: false,
    colonnes: 1,
    idChampBaseDonnees: 0,
    idUsagerCreation: '00000000-0000-0000-0000-000000000000',
    idUsagerModification: '00000000-0000-0000-0000-000000000000',
    idUsagerSuppression: null,
    dateCreation: new Date().toISOString(),
    dateModification: new Date().toISOString(),
    dateSuppression: null
  },
  {
    idFormulaireDetail: 'dad65a61-99e3-4391-891b-a7093bca2714',
    descriptionFrancaise: 'Méthode de paiement',
    descriptionAnglaise: 'Payment method',
    typeChamp: 8, // RadioGroup
    requis: true,
    affichageHorizontal: false,
    listeChoix: 'Carte de crédit;Carte de débit;Virement bancaire;Chèque',
    value: 'carte'
  },
  {
    idFormulaireDetail: '21039105-b0f5-4f26-8d92-f834587cdbd4',
    descriptionFrancaise: 'Numéro de carte',
    descriptionAnglaise: 'Card number',
    typeChamp: 1, // Text
    requis: false,
    maxLength: 19,
    placeholder: '1234 5678 9012 3456'
  },
  {
    idFormulaireDetail: '674ecf98-b0d7-47cf-a12a-bfc26ca92576',
    descriptionFrancaise: 'Date d\'expiration',
    descriptionAnglaise: 'Expiration date',
    typeChamp: 6, // Date
    requis: false
  },
  {
    idFormulaireDetail: '754aa754-57aa-4d92-a96a-02fca18a7108',
    descriptionFrancaise: 'CVV',
    descriptionAnglaise: 'CVV',
    typeChamp: 3, // Numeric
    requis: false,
    min: 100,
    max: 999,
    maxLength: 3,
    placeholder: '123'
  },
  {
    idFormulaireDetail: 'cf247d6a-f89d-423c-aa11-02e675b49c8c',
    descriptionFrancaise: 'Envoyer une confirmation par courriel',
    descriptionAnglaise: 'Send confirmation by email',
    typeChamp: 5, // CheckBox
    requis: false,
    description: 'Recevez une confirmation de votre réservation par courriel',
    valeurDefaut: true,
    value: true
  }
];

// Example with 4 sections displayed horizontally (side by side, each taking 1/4 width)
export const fourSectionsHorizontalExampleFields = [
  // Main Title
  {
    idFormulaireDetail: '3ea70a37-4f75-4dff-95de-0940ebb55d5b',
    descriptionFrancaise: 'Formulaire en 4 Sections Horizontales',
    descriptionAnglaise: 'Form with 4 Horizontal Sections',
    typeChamp: 12, // BoldTitle
    requis: false,
    idChampBaseDonnees: 0,
    idUsagerCreation: '00000000-0000-0000-0000-000000000000',
    idUsagerModification: '00000000-0000-0000-0000-000000000000',
    idUsagerSuppression: null,
    dateCreation: new Date().toISOString(),
    dateModification: new Date().toISOString(),
    dateSuppression: null
  },

  // Section 1: Informations Personnelles (leftmost column)
  {
    idFormulaireDetail: '9578e91a-e855-4df6-9c8f-4e36a1671d08',
    descriptionFrancaise: '1. INFORMATIONS PERSONNELLES',
    descriptionAnglaise: '1. PERSONAL INFORMATION',
    typeChamp: 11, // BoldLabel
    requis: false,
    colonnes: 1,
    idChampBaseDonnees: 0,
    idUsagerCreation: '00000000-0000-0000-0000-000000000000',
    idUsagerModification: '00000000-0000-0000-0000-000000000000',
    idUsagerSuppression: null,
    dateCreation: new Date().toISOString(),
    dateModification: new Date().toISOString(),
    dateSuppression: null
  },
  {
    idFormulaireDetail: '69008992-4fe0-4c30-bb97-a6d84313063f',
    descriptionFrancaise: 'Nom',
    descriptionAnglaise: 'Last name',
    typeChamp: 1, // Text
    requis: true,
    maxLength: 50,
  },
  {
    idFormulaireDetail: '6b5dd832-537e-467b-a20f-384350ec0718',
    descriptionFrancaise: 'Prénom',
    descriptionAnglaise: 'First name',
    typeChamp: 1, // Text
    requis: true,
    maxLength: 50,
    value: 'Jean'
  },
  {
    idFormulaireDetail: '04c921c3-320d-48bb-a8ea-0b4220801f30',
    descriptionFrancaise: 'Date de naissance',
    descriptionAnglaise: 'Date of birth',
    typeChamp: 6, // Date
    requis: true,
    idChampBaseDonnees: 0,
    idUsagerCreation: '00000000-0000-0000-0000-000000000000',
    idUsagerModification: '00000000-0000-0000-0000-000000000000',
    idUsagerSuppression: null,
    dateCreation: new Date().toISOString(),
    dateModification: new Date().toISOString(),
    dateSuppression: null
  },
  {
    idFormulaireDetail: '5574cfb1-5e1a-41f1-8ee9-a72831dcbe9b',
    descriptionFrancaise: 'Courriel',
    descriptionAnglaise: 'Email',
    typeChamp: 1, // Text
    requis: true,
  },

  // Section 2: Contact (second column)
  {
    idFormulaireDetail: '883a08ef-c83b-4320-9abc-dd5e0ec0203c',
    descriptionFrancaise: '2. CONTACT',
    descriptionAnglaise: '2. CONTACT',
    typeChamp: 11, // BoldLabel
    requis: false,
    colonnes: 1,
    idChampBaseDonnees: 0,
    idUsagerCreation: '00000000-0000-0000-0000-000000000000',
    idUsagerModification: '00000000-0000-0000-0000-000000000000',
    idUsagerSuppression: null,
    dateCreation: new Date().toISOString(),
    dateModification: new Date().toISOString(),
    dateSuppression: null
  },
  {
    idFormulaireDetail: 'dcceb171-1596-4e7a-8ce3-5ae7fc1610ed',
    descriptionFrancaise: 'Téléphone',
    descriptionAnglaise: 'Phone',
    typeChamp: 1, // Text
    requis: true,
    value: '514-123-4567'
  },
  {
    idFormulaireDetail: 'de67fe6d-f13c-4dff-b77d-5629da0a2157',
    descriptionFrancaise: 'Téléphone secondaire',
    descriptionAnglaise: 'Secondary phone',
    typeChamp: 1, // Text
    requis: false,
    idChampBaseDonnees: 0,
    idUsagerCreation: '00000000-0000-0000-0000-000000000000',
    idUsagerModification: '00000000-0000-0000-0000-000000000000',
    idUsagerSuppression: null,
    dateCreation: new Date().toISOString(),
    dateModification: new Date().toISOString(),
    dateSuppression: null
  },
  {
    idFormulaireDetail: 'a7c413ee-45df-4c62-874f-634a5138f710',
    descriptionFrancaise: 'Adresse',
    descriptionAnglaise: 'Address',
    typeChamp: 1, // Text
    requis: true,
    value: '123 Rue Principale'
  },
  {
    idFormulaireDetail: '70adbca9-bbb5-475c-95e6-072c5ed50fdd',
    descriptionFrancaise: 'Ville',
    descriptionAnglaise: 'City',
    typeChamp: 1, // Text
    requis: true,
    value: 'Montréal'
  },
  {
    idFormulaireDetail: '799c28df-feff-4238-ad38-fbc1eb2af990',
    descriptionFrancaise: 'Code postal',
    descriptionAnglaise: 'Postal code',
    typeChamp: 1, // Text
    requis: true,
    value: 'H1A 1A1'
  },

  // Section 3: Préférences (third column)
  {
    idFormulaireDetail: '879ff873-65c3-4e4b-8c78-ad95db6cc351',
    descriptionFrancaise: '3. PRÉFÉRENCES',
    descriptionAnglaise: '3. PREFERENCES',
    typeChamp: 11, // BoldLabel
    requis: false,
    colonnes: 1,
    idChampBaseDonnees: 0,
    idUsagerCreation: '00000000-0000-0000-0000-000000000000',
    idUsagerModification: '00000000-0000-0000-0000-000000000000',
    idUsagerSuppression: null,
    dateCreation: new Date().toISOString(),
    dateModification: new Date().toISOString(),
    dateSuppression: null
  },
  {
    idFormulaireDetail: '3431651a-5a70-41ba-a007-5c623b35cdda',
    descriptionFrancaise: 'Nombre de personnes',
    descriptionAnglaise: 'Number of people',
    typeChamp: 3, // Numeric
    requis: true,
    min: 1,
    max: 20,
    valeurDefaut: 1,
    value: 2
  },
  {
    idFormulaireDetail: '1d96da1a-c2ce-42c0-b2ff-46219a3227f9',
    descriptionFrancaise: 'Type',
    descriptionAnglaise: 'Type',
    typeChamp: 8, // RadioGroup
    requis: true,
    affichageHorizontal: false,
    listeChoix: 'Journée;Soirée;Week-end',
    value: 'weekend'
  },
  {
    idFormulaireDetail: '7df7c1fc-b5a9-4422-b278-a379e4fceb7e',
    descriptionFrancaise: 'Équipements',
    descriptionAnglaise: 'Equipment',
    typeChamp: 9, // CheckedListBox
    requis: false,
    affichageHorizontal: false,
    listeChoix: 'Tente;Sac de couchage;Réchaud',
    valeurDefaut: [],
    value: ['tente']
  },

  // Section 4: Commentaires (rightmost column)
  {
    idFormulaireDetail: 'fd956b33-1ca3-40e2-9a60-c9e549614956',
    descriptionFrancaise: '4. COMMENTAIRES',
    descriptionAnglaise: '4. COMMENTS',
    typeChamp: 11, // BoldLabel
    requis: false,
    colonnes: 1,
    idChampBaseDonnees: 0,
    idUsagerCreation: '00000000-0000-0000-0000-000000000000',
    idUsagerModification: '00000000-0000-0000-0000-000000000000',
    idUsagerSuppression: null,
    dateCreation: new Date().toISOString(),
    dateModification: new Date().toISOString(),
    dateSuppression: null
  },
  {
    idFormulaireDetail: 'fcb7169e-9fe8-453b-be9c-d1097dd0ea14',
    descriptionFrancaise: 'Commentaires',
    descriptionAnglaise: 'Comments',
    typeChamp: 2, // Memo
    requis: false,
    maxLength: 300,
    placeholder: 'Ajoutez vos commentaires...'
  },
  {
    idFormulaireDetail: '88c49e07-8888-4c4c-b688-90d6c80db5da',
    descriptionFrancaise: 'J\'accepte les conditions',
    descriptionAnglaise: 'I accept the conditions',
    typeChamp: 5, // CheckBox
    requis: true,
    description: 'Conditions générales',
    valeurDefaut: false
  }
];

// Example with 10 steps - Comprehensive multi-step form with diverse fields and layouts
export const tenStepsExampleFields = [
  // Step 0: Introduction and Basic Information
  [
    {
      idFormulaireDetail: '3d61b0e9-fa40-42b6-b66f-79ebe856a651',
      descriptionFrancaise: 'Bienvenue',
      descriptionAnglaise: 'Welcome',
      typeChamp: 12, // BoldTitle
      requis: false,
      idChampBaseDonnees: 0,
      idUsagerCreation: '00000000-0000-0000-0000-000000000000',
      idUsagerModification: '00000000-0000-0000-0000-000000000000',
      idUsagerSuppression: null,
      dateCreation: new Date().toISOString(),
      dateModification: new Date().toISOString(),
      dateSuppression: null
    },
    {
      idFormulaireDetail: 'cc91d5ec-a0e1-42ae-bf57-9fbf3ab39e99',
      descriptionFrancaise: 'Bienvenue dans notre formulaire de réservation',
      descriptionAnglaise: 'Welcome to our reservation form',
      typeChamp: 0, // Label
      requis: false,
      idChampBaseDonnees: 0,
      idUsagerCreation: '00000000-0000-0000-0000-000000000000',
      idUsagerModification: '00000000-0000-0000-0000-000000000000',
      idUsagerSuppression: null,
      dateCreation: new Date().toISOString(),
      dateModification: new Date().toISOString(),
      dateSuppression: null
    },
    {
      idFormulaireDetail: 'f964b6ae-a472-44dc-baa8-8984bad5f147',
      descriptionFrancaise: 'Nom',
      descriptionAnglaise: 'Last name',
      typeChamp: 1, // Text
      requis: true,
      maxLength: 50,
      value: '',
      idChampBaseDonnees: 0,
      idUsagerCreation: '00000000-0000-0000-0000-000000000000',
      idUsagerModification: '00000000-0000-0000-0000-000000000000',
      idUsagerSuppression: null,
      dateCreation: new Date().toISOString(),
      dateModification: new Date().toISOString(),
      dateSuppression: null
    },
    {
      idFormulaireDetail: '69361a32-d2cd-4f24-918a-df4ef1a7888b',
      descriptionFrancaise: 'Prénom',
      descriptionAnglaise: 'First name',
      typeChamp: 1, // Text
      requis: true,
      maxLength: 50,
      value: '',
      idChampBaseDonnees: 0,
      idUsagerCreation: '00000000-0000-0000-0000-000000000000',
      idUsagerModification: '00000000-0000-0000-0000-000000000000',
      idUsagerSuppression: null,
      dateCreation: new Date().toISOString(),
      dateModification: new Date().toISOString(),
      dateSuppression: null
    },
    {
      idFormulaireDetail: '1cc44ca6-162f-4019-a20d-2b8f162e5042',
      descriptionFrancaise: 'Date de naissance',
      descriptionAnglaise: 'Date of birth',
      typeChamp: 6, // Date
      requis: true,
      min: '1900-01-01',
      max: new Date().toISOString().split('T')[0]
    }
  ],

  // Step 1: Contact Information (2 columns horizontal)
  [
    {
      idFormulaireDetail: '9cc7655e-b2c0-4a6f-a16e-283f8b17ac2d',
      descriptionFrancaise: 'Informations de Contact',
      descriptionAnglaise: 'Contact Information',
      typeChamp: 12, // BoldTitle
      requis: false,
      idChampBaseDonnees: 0,
      idUsagerCreation: '00000000-0000-0000-0000-000000000000',
      idUsagerModification: '00000000-0000-0000-0000-000000000000',
      idUsagerSuppression: null,
      dateCreation: new Date().toISOString(),
      dateModification: new Date().toISOString(),
      dateSuppression: null
    },
    {
      idFormulaireDetail: 'c77a5f91-c35f-4e54-8e08-0c7bd1ab9055',
      descriptionFrancaise: 'Coordonnées',
      descriptionAnglaise: 'Contact Details',
      typeChamp: 11, // BoldLabel
      requis: false,
      colonnes: 2,
      idChampBaseDonnees: 0,
      idUsagerCreation: '00000000-0000-0000-0000-000000000000',
      idUsagerModification: '00000000-0000-0000-0000-000000000000',
      idUsagerSuppression: null,
      dateCreation: new Date().toISOString(),
      dateModification: new Date().toISOString(),
      dateSuppression: null
    },
    {
      idFormulaireDetail: 'afbf8a97-b0a4-4ffe-8bc4-f8d4390c2689',
      descriptionFrancaise: 'Courriel',
      descriptionAnglaise: 'Email',
      typeChamp: 1, // Text
      requis: true,
      value: '',
      idChampBaseDonnees: 0,
      idUsagerCreation: '00000000-0000-0000-0000-000000000000',
      idUsagerModification: '00000000-0000-0000-0000-000000000000',
      idUsagerSuppression: null,
      dateCreation: new Date().toISOString(),
      dateModification: new Date().toISOString(),
      dateSuppression: null
    },
    {
      idFormulaireDetail: '6dc464f1-8339-4dcf-aaca-26433dc8fbd3',
      descriptionFrancaise: 'Téléphone',
      descriptionAnglaise: 'Phone',
      typeChamp: 1, // Text
      requis: true,
      value: '',
      idChampBaseDonnees: 0,
      idUsagerCreation: '00000000-0000-0000-0000-000000000000',
      idUsagerModification: '00000000-0000-0000-0000-000000000000',
      idUsagerSuppression: null,
      dateCreation: new Date().toISOString(),
      dateModification: new Date().toISOString(),
      dateSuppression: null
    },
    {
      idFormulaireDetail: 'ee05e54d-5ef9-4c98-9640-ac549190aade',
      descriptionFrancaise: 'Cellulaire',
      descriptionAnglaise: 'Mobile',
      typeChamp: 1, // Text
      requis: false,
      value: '',
      idChampBaseDonnees: 0,
      idUsagerCreation: '00000000-0000-0000-0000-000000000000',
      idUsagerModification: '00000000-0000-0000-0000-000000000000',
      idUsagerSuppression: null,
      dateCreation: new Date().toISOString(),
      dateModification: new Date().toISOString(),
      dateSuppression: null
    },
    {
      idFormulaireDetail: '54498b31-fc9c-4a5b-9a60-8eefec4ba621',
      descriptionFrancaise: 'Adresse',
      descriptionAnglaise: 'Address',
      typeChamp: 1, // Text
      requis: true,
      maxLength: 100,
      value: ''
    }
  ],

  // Step 2: Address Details (vertical)
  [
    {
      idFormulaireDetail: 'f80ef90e-6583-403f-a3c6-ed5da0ac2c48',
      descriptionFrancaise: 'Détails de l\'Adresse',
      descriptionAnglaise: 'Address Details',
      typeChamp: 12, // BoldTitle
      requis: false,
      idChampBaseDonnees: 0,
      idUsagerCreation: '00000000-0000-0000-0000-000000000000',
      idUsagerModification: '00000000-0000-0000-0000-000000000000',
      idUsagerSuppression: null,
      dateCreation: new Date().toISOString(),
      dateModification: new Date().toISOString(),
      dateSuppression: null
    },
    {
      idFormulaireDetail: '095c408c-5606-4440-bbc7-46893d95eaa9',
      descriptionFrancaise: 'Localisation',
      descriptionAnglaise: 'Location',
      typeChamp: 11, // BoldLabel
      requis: false,
      colonnes: 1
    },
    {
      idFormulaireDetail: '7cb34613-003a-4b3f-861a-551a4e272726',
      descriptionFrancaise: 'Ville',
      descriptionAnglaise: 'City',
      typeChamp: 1, // Text
      requis: true,
      maxLength: 50,
      value: '',
      idChampBaseDonnees: 0,
      idUsagerCreation: '00000000-0000-0000-0000-000000000000',
      idUsagerModification: '00000000-0000-0000-0000-000000000000',
      idUsagerSuppression: null,
      dateCreation: new Date().toISOString(),
      dateModification: new Date().toISOString(),
      dateSuppression: null
    },
    {
      idFormulaireDetail: 'e90b10dd-824d-49ac-b326-40ae1e13bb5d',
      descriptionFrancaise: 'Province',
      descriptionAnglaise: 'Province',
      typeChamp: 10, // DropDownList
      requis: true,
      listeChoix: 'Québec;Ontario;Nouveau-Brunswick;Nouvelle-Écosse',
      value: 'qc'
    },
    {
      idFormulaireDetail: '8b41cf6a-ca44-4fce-8eb3-97309bd33aee',
      descriptionFrancaise: 'Code postal',
      descriptionAnglaise: 'Postal code',
      typeChamp: 1, // Text
      requis: true,
      maxLength: 10,
      value: '',
      idChampBaseDonnees: 0,
      idUsagerCreation: '00000000-0000-0000-0000-000000000000',
      idUsagerModification: '00000000-0000-0000-0000-000000000000',
      idUsagerSuppression: null,
      dateCreation: new Date().toISOString(),
      dateModification: new Date().toISOString(),
      dateSuppression: null
    },
    {
      idFormulaireDetail: '30bdbf1a-8896-4a82-9b71-f47d591ba888',
      descriptionFrancaise: 'Pays',
      descriptionAnglaise: 'Country',
      typeChamp: 10, // DropDownList
      requis: true,
      listeChoix: 'Canada;États-Unis;France',
      value: 'ca'
    }
  ],

  // Step 3: Preferences and Interests (horizontal radio/checkboxes)
  [
    {
      idFormulaireDetail: 'dc072180-e46d-4ef1-a665-7d2ed971abf1',
      descriptionFrancaise: 'Préférences et Intérêts',
      descriptionAnglaise: 'Preferences and Interests',
      typeChamp: 12, // BoldTitle
      requis: false,
      idChampBaseDonnees: 0,
      idUsagerCreation: '00000000-0000-0000-0000-000000000000',
      idUsagerModification: '00000000-0000-0000-0000-000000000000',
      idUsagerSuppression: null,
      dateCreation: new Date().toISOString(),
      dateModification: new Date().toISOString(),
      dateSuppression: null
    },
    {
      idFormulaireDetail: '6f42b6c9-abb1-450f-aa85-307acae7f800',
      descriptionFrancaise: 'Activités et Équipements',
      descriptionAnglaise: 'Activities and Equipment',
      typeChamp: 11, // BoldLabel
      requis: false,
      colonnes: 1
    },
    {
      idFormulaireDetail: 'abc5270c-be5a-4fa9-b532-b9a858f43f4d',
      descriptionFrancaise: 'Type d\'activité préféré',
      descriptionAnglaise: 'Preferred activity type',
      typeChamp: 8, // RadioGroup
      requis: true,
      affichageHorizontal: true,
      listeChoix: 'Pêche;Chasse;Randonnée;Camping',
      value: '',
      idChampBaseDonnees: 0,
      idUsagerCreation: '00000000-0000-0000-0000-000000000000',
      idUsagerModification: '00000000-0000-0000-0000-000000000000',
      idUsagerSuppression: null,
      dateCreation: new Date().toISOString(),
      dateModification: new Date().toISOString(),
      dateSuppression: null
    },
    {
      idFormulaireDetail: '56db18c9-d6db-473e-9488-84cf12277300',
      descriptionFrancaise: 'Équipements souhaités',
      descriptionAnglaise: 'Desired equipment',
      typeChamp: 9, // CheckedListBox
      requis: false,
      affichageHorizontal: true,
      listeChoix: 'Tente;Sac de couchage;Réchaud;Glacière;Lanterne',
      valeurDefaut: [],
      value: [],
      idChampBaseDonnees: 0,
      idUsagerCreation: '00000000-0000-0000-0000-000000000000',
      idUsagerModification: '00000000-0000-0000-0000-000000000000',
      idUsagerSuppression: null,
      dateCreation: new Date().toISOString(),
      dateModification: new Date().toISOString(),
      dateSuppression: null
    },
    {
      idFormulaireDetail: '342be3d3-7b97-45ee-b0be-12a1e5063dfd',
      descriptionFrancaise: 'Niveau d\'expérience',
      descriptionAnglaise: 'Experience level',
      typeChamp: 8, // RadioGroup
      requis: false,
      affichageHorizontal: false,
      listeChoix: 'Débutant;Intermédiaire;Avancé;Expert',
      value: ''
    }
  ],

  // Step 4: Reservation Details (2 columns)
  [
    {
      idFormulaireDetail: '8b6625fc-c3a4-48bd-abdf-4209ee5dfa6e',
      descriptionFrancaise: 'Détails de Réservation',
      descriptionAnglaise: 'Reservation Details',
      typeChamp: 12, // BoldTitle
      requis: false,
      idChampBaseDonnees: 0,
      idUsagerCreation: '00000000-0000-0000-0000-000000000000',
      idUsagerModification: '00000000-0000-0000-0000-000000000000',
      idUsagerSuppression: null,
      dateCreation: new Date().toISOString(),
      dateModification: new Date().toISOString(),
      dateSuppression: null
    },
    {
      idFormulaireDetail: '72be591a-f131-4164-bf28-c11cc52454fb',
      descriptionFrancaise: 'Dates et Participants',
      descriptionAnglaise: 'Dates and Participants',
      typeChamp: 11, // BoldLabel
      requis: false,
      colonnes: 2,
      idChampBaseDonnees: 0,
      idUsagerCreation: '00000000-0000-0000-0000-000000000000',
      idUsagerModification: '00000000-0000-0000-0000-000000000000',
      idUsagerSuppression: null,
      dateCreation: new Date().toISOString(),
      dateModification: new Date().toISOString(),
      dateSuppression: null
    },
    {
      idFormulaireDetail: 'dee79dd3-dba4-4e46-b730-08e408d5f377',
      descriptionFrancaise: 'Date d\'arrivée',
      descriptionAnglaise: 'Arrival date',
      typeChamp: 6, // Date
      requis: true,
      min: new Date().toISOString().split('T')[0],
      idChampBaseDonnees: 0,
      idUsagerCreation: '00000000-0000-0000-0000-000000000000',
      idUsagerModification: '00000000-0000-0000-0000-000000000000',
      idUsagerSuppression: null,
      dateCreation: new Date().toISOString(),
      dateModification: new Date().toISOString(),
      dateSuppression: null
    },
    {
      idFormulaireDetail: '2d4adc17-3ead-4225-8d53-e5009a9d839c',
      descriptionFrancaise: 'Date de départ',
      descriptionAnglaise: 'Departure date',
      typeChamp: 6, // Date
      requis: true,
      min: new Date().toISOString().split('T')[0],
      idChampBaseDonnees: 0,
      idUsagerCreation: '00000000-0000-0000-0000-000000000000',
      idUsagerModification: '00000000-0000-0000-0000-000000000000',
      idUsagerSuppression: null,
      dateCreation: new Date().toISOString(),
      dateModification: new Date().toISOString(),
      dateSuppression: null
    },
    {
      idFormulaireDetail: '5b5c1647-ad93-443d-aa7a-21ed8519691b',
      descriptionFrancaise: 'Nombre de personnes',
      descriptionAnglaise: 'Number of people',
      typeChamp: 3, // Numeric
      requis: true,
      min: 1,
      max: 20,
      valeurDefaut: 1,
      value: 1
    },
    {
      idFormulaireDetail: 'dbe1fd02-c177-4c6e-b0a9-8c26837577a5',
      descriptionFrancaise: 'Type de réservation',
      descriptionAnglaise: 'Reservation type',
      typeChamp: 8, // RadioGroup
      requis: true,
      affichageHorizontal: true,
      listeChoix: 'Journée;Soirée;Week-end;Semaine',
      value: ''
    }
  ],

  // Step 5: Financial Information (vertical)
  [
    {
      idFormulaireDetail: '67402074-41cb-41ba-a258-949cc97bff55',
      descriptionFrancaise: 'Informations Financières',
      descriptionAnglaise: 'Financial Information',
      typeChamp: 12, // BoldTitle
      requis: false,
      idChampBaseDonnees: 0,
      idUsagerCreation: '00000000-0000-0000-0000-000000000000',
      idUsagerModification: '00000000-0000-0000-0000-000000000000',
      idUsagerSuppression: null,
      dateCreation: new Date().toISOString(),
      dateModification: new Date().toISOString(),
      dateSuppression: null
    },
    {
      idFormulaireDetail: '3311086a-b149-4bb2-bdfb-defa5de1d5db',
      descriptionFrancaise: 'Paiement',
      descriptionAnglaise: 'Payment',
      typeChamp: 11, // BoldLabel
      requis: false,
      colonnes: 1
    },
    {
      idFormulaireDetail: '5ed4fc94-12fd-4c20-920b-b0599d69de1d',
      descriptionFrancaise: 'Montant',
      descriptionAnglaise: 'Amount',
      typeChamp: 4, // Decimal
      requis: false,
      min: 0,
      max: 10000,
      valeurDefaut: 0,
      value: 0
    },
    {
      idFormulaireDetail: 'f29137c8-787a-4d87-8d94-971627ca26d9',
      descriptionFrancaise: 'Méthode de paiement',
      descriptionAnglaise: 'Payment method',
      typeChamp: 8, // RadioGroup
      requis: true,
      affichageHorizontal: false,
      listeChoix: 'Carte de crédit;Carte de débit;Virement bancaire;Chèque',
      value: '',
      idChampBaseDonnees: 0,
      idUsagerCreation: '00000000-0000-0000-0000-000000000000',
      idUsagerModification: '00000000-0000-0000-0000-000000000000',
      idUsagerSuppression: null,
      dateCreation: new Date().toISOString(),
      dateModification: new Date().toISOString(),
      dateSuppression: null
    },
    {
      idFormulaireDetail: '7bf9e5eb-f9ac-4835-9484-f0bf9d37c507',
      descriptionFrancaise: 'J\'accepte les conditions générales',
      descriptionAnglaise: 'I accept the general conditions',
      typeChamp: 5, // CheckBox
      requis: true,
      description: 'J\'accepte les conditions générales de réservation',
      valeurDefaut: false,
      value: false
    }
  ],

  // Step 6: Additional Services (horizontal checkboxes)
  [
    {
      idFormulaireDetail: '1a7a815b-6f76-4725-8df2-a4d79b5bd7cc',
      descriptionFrancaise: 'Services Additionnels',
      descriptionAnglaise: 'Additional Services',
      typeChamp: 12, // BoldTitle
      requis: false,
      idChampBaseDonnees: 0,
      idUsagerCreation: '00000000-0000-0000-0000-000000000000',
      idUsagerModification: '00000000-0000-0000-0000-000000000000',
      idUsagerSuppression: null,
      dateCreation: new Date().toISOString(),
      dateModification: new Date().toISOString(),
      dateSuppression: null
    },
    {
      idFormulaireDetail: 'b56ffb9e-198d-43c9-aa72-e22c049333bf',
      descriptionFrancaise: 'Options Supplémentaires',
      descriptionAnglaise: 'Additional Options',
      typeChamp: 11, // BoldLabel
      requis: false,
      colonnes: 1
    },
    {
      idFormulaireDetail: 'ea0c5fd0-40b6-4ce3-87bf-fdb88de4705f',
      descriptionFrancaise: 'Services additionnels',
      descriptionAnglaise: 'Additional services',
      typeChamp: 9, // CheckedListBox
      requis: false,
      affichageHorizontal: true,
      listeChoix: 'Guide;Équipement;Transport;Repas;Assurance',
      valeurDefaut: [],
      value: [],
      idChampBaseDonnees: 0,
      idUsagerCreation: '00000000-0000-0000-0000-000000000000',
      idUsagerModification: '00000000-0000-0000-0000-000000000000',
      idUsagerSuppression: null,
      dateCreation: new Date().toISOString(),
      dateModification: new Date().toISOString(),
      dateSuppression: null
    },
    {
      idFormulaireDetail: 'fa455af4-b018-4da9-aa98-5c35453187de',
      descriptionFrancaise: 'Commentaires',
      descriptionAnglaise: 'Comments',
      typeChamp: 2, // Memo
      requis: false,
      maxLength: 500,
      placeholder: 'Ajoutez vos commentaires ou demandes spéciales...',
      value: ''
    }
  ],

  // Step 7: Emergency Contact (2 columns)
  [
    {
      idFormulaireDetail: '52d490ad-9481-463e-b65f-e76854391b48',
      descriptionFrancaise: 'Contact d\'Urgence',
      descriptionAnglaise: 'Emergency Contact',
      typeChamp: 12, // BoldTitle
      requis: false,
      idChampBaseDonnees: 0,
      idUsagerCreation: '00000000-0000-0000-0000-000000000000',
      idUsagerModification: '00000000-0000-0000-0000-000000000000',
      idUsagerSuppression: null,
      dateCreation: new Date().toISOString(),
      dateModification: new Date().toISOString(),
      dateSuppression: null
    },
    {
      idFormulaireDetail: '61e3833f-b370-40b4-b95b-dff077ee4d2b',
      descriptionFrancaise: 'Personne à Contacter',
      descriptionAnglaise: 'Contact Person',
      typeChamp: 11, // BoldLabel
      requis: false,
      colonnes: 2,
      idChampBaseDonnees: 0,
      idUsagerCreation: '00000000-0000-0000-0000-000000000000',
      idUsagerModification: '00000000-0000-0000-0000-000000000000',
      idUsagerSuppression: null,
      dateCreation: new Date().toISOString(),
      dateModification: new Date().toISOString(),
      dateSuppression: null
    },
    {
      idFormulaireDetail: 'a75ebd27-0365-4bed-9991-ebd0ce910f1b',
      descriptionFrancaise: 'Nom du contact',
      descriptionAnglaise: 'Contact name',
      typeChamp: 1, // Text
      requis: true,
      maxLength: 50,
      value: '',
      idChampBaseDonnees: 0,
      idUsagerCreation: '00000000-0000-0000-0000-000000000000',
      idUsagerModification: '00000000-0000-0000-0000-000000000000',
      idUsagerSuppression: null,
      dateCreation: new Date().toISOString(),
      dateModification: new Date().toISOString(),
      dateSuppression: null
    },
    {
      idFormulaireDetail: '10622e82-a95d-42cf-b567-87034b351d91',
      descriptionFrancaise: 'Relation',
      descriptionAnglaise: 'Relationship',
      typeChamp: 10, // DropDownList
      requis: true,
      listeChoix: 'Conjoint(e);Parent;Ami(e);Autre',
      value: '',
      idChampBaseDonnees: 0,
      idUsagerCreation: '00000000-0000-0000-0000-000000000000',
      idUsagerModification: '00000000-0000-0000-0000-000000000000',
      idUsagerSuppression: null,
      dateCreation: new Date().toISOString(),
      dateModification: new Date().toISOString(),
      dateSuppression: null
    },
    {
      idFormulaireDetail: '117ab933-01c7-4cc2-b65e-3c042c8ca6c7',
      descriptionFrancaise: 'Téléphone',
      descriptionAnglaise: 'Phone',
      typeChamp: 1, // Text
      requis: true,
      value: '',
      idChampBaseDonnees: 0,
      idUsagerCreation: '00000000-0000-0000-0000-000000000000',
      idUsagerModification: '00000000-0000-0000-0000-000000000000',
      idUsagerSuppression: null,
      dateCreation: new Date().toISOString(),
      dateModification: new Date().toISOString(),
      dateSuppression: null
    },
    {
      idFormulaireDetail: '9dc40ae3-b8a3-4f72-889b-30945627a48c',
      descriptionFrancaise: 'Courriel',
      descriptionAnglaise: 'Email',
      typeChamp: 1, // Text
      requis: false,
      value: ''
    }
  ],

  // Step 8: Health and Safety (vertical)
  [
    {
      idFormulaireDetail: '3e01bb76-02f9-4f4a-a9ee-6987eea13c5d',
      descriptionFrancaise: 'Santé et Sécurité',
      descriptionAnglaise: 'Health and Safety',
      typeChamp: 12, // BoldTitle
      requis: false,
      idChampBaseDonnees: 0,
      idUsagerCreation: '00000000-0000-0000-0000-000000000000',
      idUsagerModification: '00000000-0000-0000-0000-000000000000',
      idUsagerSuppression: null,
      dateCreation: new Date().toISOString(),
      dateModification: new Date().toISOString(),
      dateSuppression: null
    },
    {
      idFormulaireDetail: '829cf5ab-f7c1-48a1-ab0c-7a206d2e39d9',
      descriptionFrancaise: 'Informations Médicales',
      descriptionAnglaise: 'Medical Information',
      typeChamp: 11, // BoldLabel
      requis: false,
      colonnes: 1
    },
    {
      idFormulaireDetail: '8afb08bd-2eaa-4546-9c29-7bab2b8dbd14',
      descriptionFrancaise: 'Allergies',
      descriptionAnglaise: 'Allergies',
      typeChamp: 2, // Memo
      requis: false,
      maxLength: 300,
      placeholder: 'Indiquez vos allergies ou restrictions alimentaires...',
      value: '',
      idChampBaseDonnees: 0,
      idUsagerCreation: '00000000-0000-0000-0000-000000000000',
      idUsagerModification: '00000000-0000-0000-0000-000000000000',
      idUsagerSuppression: null,
      dateCreation: new Date().toISOString(),
      dateModification: new Date().toISOString(),
      dateSuppression: null
    },
    {
      idFormulaireDetail: '94cd8726-0792-46d9-ad22-11b1f60da9d3',
      descriptionFrancaise: 'Conditions médicales',
      descriptionAnglaise: 'Medical conditions',
      typeChamp: 2, // Memo
      requis: false,
      maxLength: 300,
      placeholder: 'Conditions médicales importantes à connaître...',
      value: '',
      idChampBaseDonnees: 0,
      idUsagerCreation: '00000000-0000-0000-0000-000000000000',
      idUsagerModification: '00000000-0000-0000-0000-000000000000',
      idUsagerSuppression: null,
      dateCreation: new Date().toISOString(),
      dateModification: new Date().toISOString(),
      dateSuppression: null
    },
    {
      idFormulaireDetail: '7e29a508-04fc-472a-b32c-02846ecd9a0b',
      descriptionFrancaise: 'J\'ai une assurance voyage valide',
      descriptionAnglaise: 'I have valid travel insurance',
      typeChamp: 5, // CheckBox
      requis: false,
      description: 'J\'ai une assurance voyage valide',
      valeurDefaut: false,
      value: false
    }
  ],

  // Step 9: Review and Confirmation (full width)
  [
    {
      idFormulaireDetail: 'c2ab6e4d-3ce1-45a2-8cc4-e5defd19c19c',
      descriptionFrancaise: 'Révision et Confirmation',
      descriptionAnglaise: 'Review and Confirmation',
      typeChamp: 12, // BoldTitle
      requis: false,
      idChampBaseDonnees: 0,
      idUsagerCreation: '00000000-0000-0000-0000-000000000000',
      idUsagerModification: '00000000-0000-0000-0000-000000000000',
      idUsagerSuppression: null,
      dateCreation: new Date().toISOString(),
      dateModification: new Date().toISOString(),
      dateSuppression: null
    },
    {
      idFormulaireDetail: 'e4011cab-aa8e-4176-b430-87bbf7b1b56e',
      descriptionFrancaise: 'Finalisation',
      descriptionAnglaise: 'Finalization',
      typeChamp: 11, // BoldLabel
      requis: false,
      colonnes: 1,
      pleineLargeur: true,
      idChampBaseDonnees: 0,
      idUsagerCreation: '00000000-0000-0000-0000-000000000000',
      idUsagerModification: '00000000-0000-0000-0000-000000000000',
      idUsagerSuppression: null,
      dateCreation: new Date().toISOString(),
      dateModification: new Date().toISOString(),
      dateSuppression: null
    },
    {
      idFormulaireDetail: '67a4570d-2cc3-4a97-bad9-f765d575ecc1',
      descriptionFrancaise: 'Veuillez réviser toutes les informations que vous avez saisies. Une fois que vous êtes satisfait, cochez la case ci-dessous pour finaliser votre réservation.',
      descriptionAnglaise: 'Please review all the information you have entered. Once you are satisfied, check the box below to finalize your reservation.',
      typeChamp: 0, // Label
      requis: false,
      idChampBaseDonnees: 0,
      idUsagerCreation: '00000000-0000-0000-0000-000000000000',
      idUsagerModification: '00000000-0000-0000-0000-000000000000',
      idUsagerSuppression: null,
      dateCreation: new Date().toISOString(),
      dateModification: new Date().toISOString(),
      dateSuppression: null
    },
    {
      idFormulaireDetail: 'f3df8dd4-623d-4d4b-b28d-6bf141a9f821',
      descriptionFrancaise: 'Je confirme que toutes les informations sont exactes',
      descriptionAnglaise: 'I confirm that all information is accurate',
      typeChamp: 5, // CheckBox
      requis: true,
      description: 'Je confirme que toutes les informations sont exactes et je souhaite finaliser ma réservation',
      valeurDefaut: false,
      value: false
    },
    {
      idFormulaireDetail: 'c77c2688-cc54-4f86-a82c-1c83ad8caa7f',
      descriptionFrancaise: 'Je souhaite recevoir la newsletter',
      descriptionAnglaise: 'I wish to receive the newsletter',
      typeChamp: 5, // CheckBox
      requis: false,
      description: 'Je souhaite recevoir la newsletter et les offres spéciales',
      valeurDefaut: false,
      value: false
    }
  ]
];
